import { ChatCompletionsMessageObject } from "../../../services/api/instances/completionsApi/types";
import { TDeerFlowMessage } from "../../../services/api/instances/deerflowApi/types";

export function convertMessages(
  messages: TDeerFlowMessage[],
): ChatCompletionsMessageObject[] {
  return messages
    .filter(
      (msg) =>
        msg.content !== undefined &&
        msg.content !== null &&
        msg.content !== "" &&
        msg.type !== "tool",
    )
    .map((msg) => ({
      role: msg.type === "human" ? "user" : "assistant",
      content:
        typeof msg.content === "string"
          ? msg.content
          : Array.isArray(msg.content) && msg.content.length > 0
            ? msg.content[0].text
            : "",
      id: msg.id,
    }))
    .slice(1);
}
